/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for AccreditationResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, StructureAccreditationListDTO, StructureAccreditationViewDTO } from "../models";

@Injectable({ providedIn: "root" })
export class AccreditationResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    getStructureAccreditations(valide?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<StructureAccreditationListDTO>>;
    getStructureAccreditations(valide?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<StructureAccreditationListDTO>>>;
    getStructureAccreditations(valide?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<StructureAccreditationListDTO>>>;
    getStructureAccreditations(valide?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accreditations/structures`;

        let params = new HttpParams();
        if (valide != null) {
            params = HttpParamsBuilder.addToHttpParams(params, valide, 'valide');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addAccreditation(structureAccreditationViewDTO: StructureAccreditationViewDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<StructureAccreditationViewDTO>;
    addAccreditation(structureAccreditationViewDTO: StructureAccreditationViewDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<StructureAccreditationViewDTO>>;
    addAccreditation(structureAccreditationViewDTO: StructureAccreditationViewDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<StructureAccreditationViewDTO>>;
    addAccreditation(structureAccreditationViewDTO: StructureAccreditationViewDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accreditations/structures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: structureAccreditationViewDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAccreditation(structureAccreditationViewDTO: StructureAccreditationViewDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<StructureAccreditationViewDTO>;
    updateAccreditation(structureAccreditationViewDTO: StructureAccreditationViewDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<StructureAccreditationViewDTO>>;
    updateAccreditation(structureAccreditationViewDTO: StructureAccreditationViewDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<StructureAccreditationViewDTO>>;
    updateAccreditation(structureAccreditationViewDTO: StructureAccreditationViewDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accreditations/structures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: structureAccreditationViewDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    changeVisibility(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<StructureAccreditationViewDTO>;
    changeVisibility(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<StructureAccreditationViewDTO>>;
    changeVisibility(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<StructureAccreditationViewDTO>>;
    changeVisibility(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accreditations/structures/visible/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    changeStatus(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<StructureAccreditationViewDTO>;
    changeStatus(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<StructureAccreditationViewDTO>>;
    changeStatus(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<StructureAccreditationViewDTO>>;
    changeStatus(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accreditations/structures/status/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveStructure(id: number, motif: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<StructureAccreditationViewDTO>;
    archiveStructure(id: number, motif: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<StructureAccreditationViewDTO>>;
    archiveStructure(id: number, motif: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<StructureAccreditationViewDTO>>;
    archiveStructure(id: number, motif: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accreditations/structures/archive/${id}`;

        let params = new HttpParams();
        if (motif != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motif, 'motif');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAccreditationById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<StructureAccreditationViewDTO>;
    getAccreditationById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<StructureAccreditationViewDTO>>;
    getAccreditationById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<StructureAccreditationViewDTO>>;
    getAccreditationById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accreditations/structures/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findStructureAccreditation(intitule?: string, sigle?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<StructureAccreditationViewDTO>;
    findStructureAccreditation(intitule?: string, sigle?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<StructureAccreditationViewDTO>>;
    findStructureAccreditation(intitule?: string, sigle?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<StructureAccreditationViewDTO>>;
    findStructureAccreditation(intitule?: string, sigle?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accreditations/structures/existe-accreditation`;

        let params = new HttpParams();
        if (intitule != null) {
            params = HttpParamsBuilder.addToHttpParams(params, intitule, 'intitule');
        }
        if (sigle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, sigle, 'sigle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
